import { SelectedReserveType } from "@/atoms/shared"
import BigNumber from "bignumber.js"
import { SLOTS_PER_YEAR } from "../rate"

export const createConfigShowingAPR = (reserve: SelectedReserveType) => {
  return {
    protocolTakeRate: reserve.interestRateSpread,
    isShowingAPY: false,
    borrowedAmount: reserve.totalBorrow,
    availableAmount: reserve.availableAmount,
    optimalUtilizationRate: reserve.targetUtilization,
    maxUtilizationRate: reserve.maxUtilizationRate,
    minBorrowRate: reserve.minBorrowApr,
    optimalBorrowRate: reserve.targetBorrowApr,
    maxBorrowRate: reserve.maxBorrowApr,
    superMaxBorrowRate: reserve.superMaxBorrowRate,
    accumulatedProtocolFees: reserve.accumulatedProtocolFeesWad,
    decimals: reserve.decimals,
  }
}

export const calculateCompoundedInterestRate = (currentBorrowRate: BigNumber, slotElapsed: number) => {
  const slotInterestRate = currentBorrowRate.div(SLOTS_PER_YEAR)
  const compoundInterestRate = (1 + slotInterestRate.toNumber()) ** slotElapsed
  return compoundInterestRate
}
